/// <reference path="./types.js" />

/** @type {StateObj} */
const defaultState = {
  start: false,
  difficulty: 'easy',
  repeat: true,
  round: 1,
  sequence: [],
  input: [],
  sequenceIndex: 0,
  keydown: null,
  keycallbacks: {},
  block: false,
  attempt: [],
  feedback: null,
};

class State {
  /** @type {StateObj} */
  stateObj;

  constructor() {
    this.init();
  }

  /**
   * Wraps the state object with Proxy.
   * @returns {any}
   * @private
   */
  init() {
    this.stateObj = new Proxy(defaultState, {
      /**
       * Returns a state's property value.
       * @template {keyof StateObj} K
       * @param {StateObj} stateObj
       * @param {K} property
       * @returns {StateObj[K]}
       */
      get(stateObj, property) {
        return stateObj[property];
      },

      /**
       * Sets a property in the state object and dispatches an event if the property has changed.
       * @template {keyof StateObj} T
       * @param {StateObj} stateObj
       * @param {T} property
       * @param {StateObj[T]} value
       * @returns {boolean}
       */
      set(stateObj, property, value) {
        if (stateObj[property] !== value) {
          stateObj[property] = value;

          window.dispatchEvent(
            new CustomEvent(`change${property}`, {
              detail: { [property]: value },
            })
          );
        }

        return true;
      },
    });
  }
}

export default new State().stateObj;
